const firebaseConfig = {
     apiKey: "AIzaSyBYszkYqPGDN8bynbGoSK_vO1Zxd-d9AdI",
     authDomain: "medi-life-authentication.firebaseapp.com",
     projectId: "medi-life-authentication",
     storageBucket: "medi-life-authentication.appspot.com",
     messagingSenderId: "647017515847",
     appId: "1:647017515847:web:600b269fdd286ac47d1a62"
   };

export default firebaseConfig;